import Api from './BaseRequest';

const Get = (contractId) => {
    const params = {}
    if (contractId) {
        params.contract_id = contractId;
    }
    return Api.Get('/api/account', params)
};

const Send = (email) => {
    return Api.Post('/api/account/send', { email })
};
const GetContracts = () => {
    return Api.Get('/api/company-contracts')
};


export default {
    Get,
    Send,
    GetContracts,
};
